module.exports = __webpack_public_path__ + "static/media/carchex-logo-offer.52f8badb.png";